import type { RecipProcedure } from '../../types';

export function countHeatsNotUsed(procedures: RecipProcedure[]): number {
  return procedures.filter(
    (p) => p.procCode?.trim().toLowerCase() === 'heat not used',
  ).length;
}
